import { FieldSchema } from "../../../Schema";
import { LinkedInstance } from "../external-sources/LinkedInstances";
import { User } from "../external-sources/Users";
import { EntryTypes } from "./entryType";
import { Modes } from "./mode";
import { readStoredText, writeStoredText } from "./stored";

export const equipmentNickName: FieldSchema = {
  name: "equipmentNickName",
  grid: {
    displayed: true,
    order: 37,
  },
  // Declared for both inbound directions: the rule belongs to the attribute, not to
  // whether the record arrived from AppSync or from a DynamoDB read.
  dataTransform: {
    fromGraphql: { getter: ({ equipmentNickName }) => readStoredText(equipmentNickName) },
    fromDb: { getter: ({ equipmentNickName }) => readStoredText(equipmentNickName) },
    // Back out as the placeholder: this column is one an index is keyed on, or
    // one the resolvers keep a placeholder in for a consumer's index.
    toDb: { getter: ({ equipmentNickName }) => writeStoredText(equipmentNickName) },
  },
  display: {
    displayed: true,
  },
  form: {
    label: "Nickname",
    disabled: {
      getter: ({ entryType, linkedInstance, mode, currentUser }) => {
        return (
          [EntryTypes.STANDALONE_EQUIPMENT, EntryTypes.CLUSTER_SUBEQUIPMENT].includes(entryType as EntryTypes) &&
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Bi-Directional","P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["entryType", "linkedInstance", "mode", "currentUser"],
    },
  },
};
